var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MDCRipple } from '@material/ripple';
const map = {
    text: '',
    outlined: 'mdc-button--outlined',
    unelevated: 'mdc-button--unelevated',
    raised: 'mdc-button--raised'
};
let MButton = class MButton extends Vue {
    get buttonClasses() {
        return map[this.variant];
    }
    mounted() {
        this.mdcRipple = new MDCRipple(this.$el);
        this.mdcRipple.unbounded = false;
        this.onRippleProp();
    }
    render(h) {
        let classes = 'mdc-button m-button';
        if (this.buttonClasses) {
            classes = `${classes} ${this.buttonClasses}`;
        }
        return h('button', {
            staticClass: classes,
            attr: this.$attrs,
            on: {
                click: (e) => this.$emit('click', e)
            }
        }, this.$slots.default);
    }
    blur() {
        this.$el.blur();
    }
    onRippleProp() {
        this.mdcRipple.disabled = !this.ripple;
    }
};
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], MButton.prototype, "ripple", void 0);
__decorate([
    Prop({ default: 'text' }),
    __metadata("design:type", String)
], MButton.prototype, "variant", void 0);
__decorate([
    Watch('ripple'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MButton.prototype, "onRippleProp", null);
MButton = __decorate([
    Component({})
], MButton);
export { MButton };
//# sourceMappingURL=Button.js.map